<template>
  <v-expansion-panels class="mb-4">
    <v-expansion-panel
      style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;"
    >
      <v-expansion-panel-header id="support-filter-header"
        >Tìm kiếm yêu cầu</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <v-list-item three-line class="overflow-visible pa-0">
          <v-list-item-content class="overflow-visible pa-0">
            <validation-observer v-slot="{ handleSubmit }">
              <v-row>
                <v-col cols="12" md="4" sm="12">
                  <common-range-picker
                    :clearable="true"
                    :aLight="'right'"
                    label="Ngày tạo"
                    v-model="filterForm.activatedAt"
                    :defaultRange="defaultRange"
                  />
                </v-col>
                
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="filterForm.name"
                    label="Tên người gửi"
                    placeholder="Nhập tên người gửi"
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="filterForm.ad_id"
                    label="ID quảng cáo"
                    placeholder="Nhập ID quảng cáo"
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="filterForm.content_id"
                    label="Id nội dung"
                    placeholder="Nhập ID nội dung."
                    clearable
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="filterForm.sender_id"
                    label="ID người gửi"
                    placeholder="Nhập ID người gửi"
                    clearable
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn class="primary mx-0" @click="handleSubmit(searchList)">
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </validation-observer>
          </v-list-item-content>
        </v-list-item>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import moment from "moment";
import { regex } from "@/helpers/constants";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const SupportRepository = RepositoryFactory.get("support");
import { LIST_STATUS_SUPPORT } from "@/helpers/constants";

export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultRange: {
        // startDate: moment()
        //   .startOf("isoWeek")
        //   .format("YYYY-MM-DD"),
        // endDate: moment()
        //   .endOf("isoWeek")
        //   .format("YYYY-MM-DD"),
      },
      reRender: 0,
      ticketTypeNames: [],
      groupTickes: [],
      regex,
      filterForm: {
        startDateTime: moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD"),
        endDateTime: moment()
          .endOf("isoWeek")
          .format("YYYY-MM-DD"),
        ticketGroupId: null,
        ticketTypeId: null,
      },
      menuStart: false,
      menuEnd: false,
      listStatusSupport: LIST_STATUS_SUPPORT,
      groupTickesClone: [],
      ticketTypeQuerry: null,
    };
  },
  watch: {
    "filterForm.ticketGroupId": function(id) {
      this.filterForm.ticketTypeId = null;
      if(this.ticketTypeQuerry && !this.reRender) {
        this.filterForm.ticketTypeId = this.ticketTypeQuerry
      }
      this.ticketTypeNames = [];
      this.reRender++;
      if (!id) {
        this.ticketTypeNames = [];
        return;
      }
      this.ticketTypeNames = this.groupTickesClone.filter(
        (item) => item.id == id
      )[0].TicketGroupType;
    },
  },
  async created() {
    await this.getGroupTickets();
    this.filterForm.customerCode = this.$route.query?.nameCode;
    this.filterForm.createdName = this.$route.query?.createdName;
    this.defaultRange = {
      startDate: this.$route.query?.createdAt
        ? moment(this.$route.query?.createdAt).format("YYYY-MM-DD")
        : null,
      endDate: this.$route.query?.createdAt
        ? moment(this.$route.query?.createdAt).format("YYYY-MM-DD")
        : null,
    };
    if(this.$route.query?.createdAt){
          this.filterForm.activatedAt = [moment(this.$route.query?.createdAt).format('YYYY-MM-DD'), moment(this.$route.query?.createdAt).format('YYYY-MM-DD')]
    }
  },
  methods: {
    async getGroupTickets() {
      let res = await SupportRepository.getGroupTickets();
      if (res.success) {
        this.groupTickes = _.get(res, "data", []);
        this.groupTickesClone = _.cloneDeep(this.groupTickes);
        this.groupTickes = this.groupTickes.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      }
    },
    changeDateRange(dateRange) {
      this.filterForm.startDateTime = dateRange.startDate;
      this.filterForm.endDateTime = dateRange.endDate;
    },
    searchList() {
      // let element = document.getElementById("support-filter-header");
      // if (element) {
      //   element.click();
      // }
      let formData = {
        ...this.filterForm,
        ticketGroupId: this.filterForm.ticketGroupId,
      };
      Bus.$emit("search-request-support-list-2", formData);
    },
  },
};
</script>

<style lang="scss">
button#support-filter-header {
  font-weight: 900;
  color: #777;
  display: flex;
  flex-direction: row-reverse;
  justify-content: left;
  align-content: center;
  .v-expansion-panel-header__icon {
    margin-left: 0 !important;
    border: 1px solid #a9a9a9;
    margin-right: 10px;
    border-radius: 5px;
  }
}
</style>
